import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import type { Observable } from 'rxjs';
import { firstValueFrom } from 'rxjs';

import type { IPage } from 'components/organisms/widgets-loader/entities/types';
import { WidgetsService } from 'components/organisms/widgets-loader/widgets.service';
import { WIDGETS_CONFIG } from 'components/widgets/widgets-config';
import { HTTP_ERROR_HANDLER_SERVICE } from 'src/services/http-error-handler/entities/const';
import type { IHttpErrorHandlerService } from 'src/services/http-error-handler/entities/types';

@Injectable()
export class PreviewViewResolverService {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly httpErrorHandlerService = inject<IHttpErrorHandlerService>(HTTP_ERROR_HANDLER_SERVICE);
    private readonly widgetsService = inject(WidgetsService);

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        if (isPlatformBrowser(this.platformId)) {
            window.parent.postMessage('get_preview_data', '*');
            return new Promise((resolve) => {
                window.addEventListener('message', async ({ data }) => {
                    if (data.type && data.type === 'preview_data') {
                        const page = data.page as IPage | null;
                        if (page?.widgets) {
                            await firstValueFrom(this.widgetsService.resolveWidgetsFromPage(page, WIDGETS_CONFIG));
                        } else {
                            this.widgetsService.markNoWidgets();
                        }
                        resolve(page);
                    }
                });
            });
        }

        return Promise.resolve(null);
    }
}
